export default __webpack_public_path__ + "static/media/SacredQ.d5e3750df55b780e1c477b014deb4b61.webp";